module.exports = __webpack_public_path__ + "img/coriolis.33d270aa.svg";